import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsComponent } from './forms.component'
import { formsRoutes } from './forms.routing'
import { CreateFormComponent } from './create-form/create-form.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { UpdateFormComponent } from './update-form/update-form.component'
import { LottieComponent } from 'ngx-lottie'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [FormsComponent, CreateFormComponent, UpdateFormComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(formsRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
    LottieComponent,
    BreadcrumbsModule,
  ],
  exports: [FormsComponent],
})
export class FormsModule {}
